import React from 'react'
import Portal from 'components/Portal/Portal'
import shortid from 'shortid'
import MountDetector from 'components/MountDetector/MountDetector'

const WIZARD_BODY_SELECTOR = 'wizard-body-scroll-container'

const FieldTooltip = ({ tooltip }) => {
  const [shown, setShown] = React.useState(false)
  const [wrapperStyle, setWrapperStyle] = React.useState({})
  const trigger = React.useRef()
  const wrapper = React.useRef()
  const tipId = React.useRef(shortid.generate())

  const positionTooltip = () => {
    if(trigger.current && wrapper.current){
      const triggerRect = trigger.current.getBoundingClientRect()
      const wrapperRect = wrapper.current.getBoundingClientRect()

      let left = triggerRect.left + triggerRect.width / 2 - wrapperRect.width / 2
      let top = triggerRect.top - wrapperRect.height - 10

      if (left < 10) {
        left = 10
      }

      if (top < 10) {
        top = 10
      }

      setWrapperStyle({ transform: `translate(${left}px, ${top}px)` })
      setShown(true)
    }
  }

  React.useEffect(() => {
    if (shown) {
      document.addEventListener('scroll', positionTooltip)
      document.getElementById(WIZARD_BODY_SELECTOR).addEventListener('scroll', positionTooltip)
      window.addEventListener('resize', positionTooltip)
    }

    return () => {
      document.removeEventListener('scroll', positionTooltip)
      document.getElementById(WIZARD_BODY_SELECTOR) && document.getElementById(WIZARD_BODY_SELECTOR).removeEventListener('scroll', positionTooltip)
      window.removeEventListener('resize', positionTooltip)
    }
  }, [shown])

  const hideTooltip = () => {
    if (document.activeElement !== trigger.current) {
      setShown(false)
    }
  }

  return (
    <span
      ref={trigger}
      className="tip tooltip-trigger"
      onClick={e => {
        e.stopPropagation()
        e.preventDefault()
      }}
      onMouseEnter={positionTooltip}
      onMouseOut={hideTooltip}
      onFocus={positionTooltip}
      onBlur={hideTooltip}
      tabIndex={0}
      aria-label="tooltip"
      aria-describedby={tipId.current}
    >
      i
      <Portal isOpened>
        <div
          role="tooltip"
          className={`tooltip-wrapper`}
          style={{ ...wrapperStyle, opacity: shown ? 1 : 0 }}
          id={tipId.current}
          ref={wrapper}
        >
          {tooltip}
          <MountDetector onMounted={() => {
            if(document.activeElement === trigger.current){
              positionTooltip()
            }
          }} />
        </div>
      </Portal>
    </span>
  )
}

export default FieldTooltip
